module.exports = __webpack_public_path__ + "img/silver3.e59fe34e.png";